import { type SyncActions } from '@/constants/constants';

export const SyncStatus = {
	STATUS_WARNING: 'status-warning',
	STATUS_SUCCESS: 'status-success',
	STATUS_DEFAULT: 'status-default',
	STATUS_ERROR: 'status-error',
} as const;

export type SyncActionType = (typeof SyncActions)[keyof typeof SyncActions];
export type SyncStatusType = (typeof SyncStatus)[keyof typeof SyncStatus];

export type IntegrationActionItem = {
	type: SyncActionType;
	icon: string;
	title: string;
	href?: string;
	syncStatus?: SyncStatusType;
	errorCount?: number;
};
